import { axios } from '../context/AuthContext';

const ensureApiSuccess = (data, fallbackMessage) => {
  if (data?.success === false) {
    const error = new Error(data?.message || fallbackMessage);
    error.response = { data };
    throw error;
  }
  return data;
};

export const previewTxtTemplate = async (files = []) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  const { data } = await axios.post('/denemeler/optik-sablonlar/txt-onizleme', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return ensureApiSuccess(data, 'TXT önizleme başarısız.');
};

export const saveTxtSelections = async (payload) => {
  const { data } = await axios.post('/denemeler/optik-sablonlar/txt-secimleri-kaydet', payload);
  return ensureApiSuccess(data, 'TXT şablon kaydı başarısız.');
};

export const uploadTxtResults = async ({ denemeId, files = [], sablonId }) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));
  if (sablonId) formData.append('sablon_id', String(sablonId));

  const { data } = await axios.post('/denemeler/' + denemeId + '/optik-txt-yukle', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return ensureApiSuccess(data, 'TXT yükleme başarısız.');
};
